import { useState } from "react";
import { viewableUrlFile } from "../../utils/utilityFunction";
import { Box, Skeleton } from "@mui/material";

import "./showItem.css";

const ShowItem = ({ title, imageUrl, onEdit, onClick, onDelete, bgColor }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const imgUrl = viewableUrlFile(imageUrl);

  return (
    <Box component="div" className="cardNew" sx={{ width: "100%" }}>
      <Box component="div" className={`card__sideNew`} onClick={onClick}>
        <img
          id="blah"
          className={`card__pictureNew ${
            isLoaded ? "card_animation" : "displayNone"
          }`}
          src={`${process.env.REACT_APP_FILE_LOCATION}${imgUrl}`}
          alt={title}
          onLoad={() => setIsLoaded(true)}
        />
        {!isLoaded && (
          <Skeleton
            variant="rectangular"
            sx={{ width: "85%", height: "85%", minHeight: "300px" }}
          />
        )}
      </Box>

      {onDelete && onEdit && (
        <Box className="card__btn">
          <button className="btn btn__delete" onClick={onDelete}>
            Delete
          </button>

          <button className="btn btn__edit" onClick={onEdit}>
            Edit
          </button>
        </Box>
      )}
    </Box>
  );
};

export default ShowItem;
